import { MessagePrimitive, useAuiState } from "@assistant-ui/react";
import { AttachmentList } from "@circle-react-shared/AiConversation/composer/Attachments/AttachmentList";
import { hasMeaningfulContent } from "@circle-react-shared/AiConversation/composer/TipTapComposer/tiptapToAnnotatedText";
import { CopyMessageAction } from "@circle-react-shared/AiConversation/message/CopyMessageAction";
import { MessageActions } from "@circle-react-shared/AiConversation/message/MessageActions";
import { UserMessageBubble } from "@circle-react-shared/AiConversation/message/UserMessageBubble";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Avatar } from "@circleco/compass/components/Avatar";
import { Typography } from "@circleco/compass/components/Typography";

import { AiPauseDivider } from "./AiPauseDivider";
import type { AvatarMessageMetadata } from "./avatarThreadMessages";
import { avatarPartComponents } from "./TiptapBodyPart";

export const AvatarUserMessage = () => {
  const {
    adminAuthor,
    aiPauseChange: isAiPaused,
    attachments,
    tiptap_body: tiptapBody,
  } = useAuiState(
    s => s.message.metadata.custom as AvatarMessageMetadata | undefined,
  ) ?? {};
  const hasAttachments = !!attachments?.length;
  const shouldShowTextBubble =
    !hasAttachments || hasMeaningfulContent(tiptapBody ?? {});
  const alignment = adminAuthor ? "start" : "end";

  return (
    <MessagePrimitive.Root data-testid="avatar-user-message">
      {isAiPaused !== undefined && <AiPauseDivider isPaused={isAiPaused} />}
      <div
        className={classNames("flex flex-col gap-2 pt-5", {
          "items-start": !!adminAuthor,
          "items-end": !adminAuthor,
        })}
      >
        {adminAuthor && (
          <div className="flex items-center gap-2">
            <Avatar
              size="sm"
              src={adminAuthor.avatar_url}
              name={adminAuthor.name}
              decorative
            />
            <Typography variant="label-sm" color="secondary">
              {adminAuthor.name}
            </Typography>
          </div>
        )}
        {hasAttachments && (
          <AttachmentList
            attachments={attachments}
            className={shouldShowTextBubble ? undefined : "peer/bubble"}
          />
        )}
        {shouldShowTextBubble && (
          <UserMessageBubble align={alignment} actions={<CopyMessageAction />}>
            <MessagePrimitive.Parts components={avatarPartComponents} />
          </UserMessageBubble>
        )}
        {!shouldShowTextBubble && (
          <MessageActions actionsAlignment={alignment} showTime />
        )}
      </div>
    </MessagePrimitive.Root>
  );
};
